import { Blockquote, Inset, Text } from "@radix-ui/themes";


export default function Y2024M07() {

  return (
    <>
      <div className="container py-5">
        <div className='row'>

          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2024-07-01.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
                &copy; IRPY
              </Text>
            </Inset>
          </div>

          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                  14-21 July 2024, Boca do Acre, Amazonas State (Brazil)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                    Participation in the <i>First Ancestral Wisdom Gathering of Amerindian Traditions</i>
                  </Blockquote>
                  <Blockquote size="2" color>
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    As a result of the workshop <i>Non-Western Forms of Knowledge and their Importance for European Culture</i>, Amanda Viana de Sousa was invited by Brazilian anthropologist Fernanda Gebara to participate as volunteer in this special event at the Amazonian rainforest in which midwives, connoisseurs of medicinal plants, spiritual leaders, shamans, healers and ritual experts from different indigenous groups gathered together to exchange ancestral knowledge and reflect on its preservation.
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
